import {getPrefixedLogger} from '@netx/core-logger';
import type {ILegacyAction} from '@netx/core-actions';

const logger = getPrefixedLogger('core/legacyActionManager');

const navigation: ILegacyAction[] = [];

export const ExtendLegacyAction = (action: ILegacyAction | ILegacyAction[]) => {
	if (Array.isArray(action)) return action.forEach(ExtendLegacyAction);

	if (!action?.event)
		throw new Error(`bad argument to \`ExtendLegacyAction\`: ${action}`);

	const existingAction = navigation.find((a) => a.event === action.event);
	if (!existingAction)
		return logger.warn(
			`action \`${action.event}\` has not been defined > use \`RegisterLegacyAction\` in place of \`ExtendLegacyAction\``,
		);

	Object.assign(existingAction, action);
};

export const FindLegacyAction = (actionKey: string) =>
	navigation.find((a) => a.event === actionKey);

export const RegisterLegacyAction = (
	action: ILegacyAction | ILegacyAction[],
) => {
	if (Array.isArray(action)) return action.forEach(RegisterLegacyAction);

	if (!action?.event)
		throw new Error(`bad argument to \`RegisterLegacyAction\`: ${action}`);

	const existingAction = navigation.find((a) => a.event === action.event);
	if (existingAction)
		return logger.warn(
			`action \`${action.event}\` has already been defined > use \`ExtendLegacyAction\` in place of \`RegisterLegacyAction\``,
		);

	navigation.push(action);
};

export default {
	ExtendLegacyAction,
	FindLegacyAction,
	RegisterLegacyAction,
};
